var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepBox"},[_c('qiangzhi',{attrs:{"type":3}}),_c('fengxian',{attrs:{"type":3}}),_c('fuwu',{attrs:{"type":3}}),_c('mElectronicFooter',{ref:"footer",on:{"nextClick":_vm.nextClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }